
import React, { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { useAuth } from "@/hooks/useAuth";
import { Skeleton } from '@/components/ui/skeleton';

const Index = () => {
  const navigate = useNavigate();
  const { profile, loading } = useAuth();

  useEffect(() => {
    // Only attempt navigation when loading is complete
    if (loading) return;
    
    console.log("Index redirect: Loading complete, user profile:", profile);
    
    // Single immediate navigation without state updates
    if (profile) {
      console.log(`Redirecting authenticated user with role: ${profile.role}`);
      switch (profile.role) {
        case 'admin':
        case 'administrator':
          navigate("/admin", { replace: true });
          break;
        case 'organization':
        case 'organization_user':
          navigate("/organization", { replace: true });
          break;
        default:
          navigate("/flight-board", { replace: true });
          break;
      }
    } else {
      console.log("Redirecting unauthenticated user to flight board");
      navigate("/flight-board", { replace: true });
    }
  }, [profile, loading, navigate]);

  // Return a simple loading indicator while determining where to redirect
  return (
    <div className="flex items-center justify-center h-[50vh]">
      <div className="text-center">
        <Skeleton className="h-8 w-48 mx-auto mb-2" />
        <p className="text-gray-500">Redirecting...</p>
      </div>
    </div>
  );
};

export default Index;
